import { render } from "./AddDestination.vue?vue&type=template&id=6f2328fd&scoped=true"
import script from "./AddDestination.vue?vue&type=script&lang=js"
export * from "./AddDestination.vue?vue&type=script&lang=js"

import "./AddDestination.vue?vue&type=style&index=0&id=6f2328fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f2328fd"

export default script